module.exports = __webpack_public_path__ + "static/media/arrow-left-thin.35e24a76.svg";